import React from 'react'
import PropTypes from 'prop-types'
import { useTranslation } from 'react-i18next'
import { Badge } from '@/components/ui/badge'
import { Tooltip, TooltipContent, TooltipTrigger } from '@/components/ui/tooltip'
import { isKYCComplete } from '@/utils/kycValidation'

/**
 * Composant réutilisable pour afficher le badge KYC d'un freelancer
 * Affiche un badge vert si le KYC est complet, orange sinon
 * Inclut un tooltip avec le statut détaillé
 */
const KYCBadge = ({ freelancer }) => {
  const { t } = useTranslation()
  const kycComplete = isKYCComplete(freelancer)

  return (
    <Tooltip>
      <TooltipTrigger asChild>
        <Badge
          variant={kycComplete ? 'default' : 'destructive'}
          className={
            kycComplete
              ? 'rounded-full bg-green-100 text-green-700 border border-green-500 hover:bg-green-100 h-4 px-1 text-[10px] cursor-help'
              : 'rounded-full bg-orange-100 text-orange-700 border border-orange-500 hover:bg-orange-100 h-4 px-1 text-[10px] cursor-help'
          }
        >
          KYC
        </Badge>
      </TooltipTrigger>
      <TooltipContent>
        <p>
          {kycComplete
            ? t('freelancers.kyc.complete')
            : t('freelancers.kyc.incomplete')}
        </p>
      </TooltipContent>
    </Tooltip>
  )
}

KYCBadge.propTypes = {
  freelancer: PropTypes.object.isRequired,
}

export default KYCBadge
